import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { SidebarSubmenuProps } from './types';

export function SidebarSubmenu({ items, currentPath, onNavigate }: SidebarSubmenuProps) {
  const { t } = useTranslation('layout');
  return (
    <div className="ml-6 mt-1 space-y-1 border-l-2 border-blue-700 pl-4">
      {items.map((subItem, subIndex) => {
        const SubIconComponent = subItem.icon;
        const isActive = currentPath === subItem.path;
        return (
          <button
            key={subIndex}
            onClick={() => onNavigate(subItem.path)}
            className={cn(
              'flex items-center gap-2 w-full px-3 py-2 text-sm rounded-md transition-colors cursor-pointer',
              isActive
                ? 'bg-blue-700 text-white'
                : 'text-blue-200 hover:bg-blue-800 hover:text-white',
            )}
          >
            <SubIconComponent size={20} className="text-white" />
            <span>{t(subItem.title)}</span>
          </button>
        );
      })}
    </div>
  );
}
